import { useCallback } from 'react';

import { useInterfaceLanguage } from '@/shared/i18n';
import { formatInterfaceCurrency } from '@/shared/i18n/formatLocale';

export const usePriceFormatting = () => {
  const { locale } = useInterfaceLanguage();
  const formatPrice = useCallback(
    (amount: number, currency: string) => {
      return formatInterfaceCurrency(locale, amount, currency);
    },
    [locale],
  );

  const calculateVATPercentage = useCallback((taxAmount: number | undefined, totalAmount: number) => {
    if (!taxAmount || !totalAmount) return '0%';
    const percentage = (taxAmount / totalAmount) * 100;
    return `${Math.round(percentage)}%`;
  }, []);

  return { calculateVATPercentage, formatPrice };
};
